<script>
import moment from 'moment'
import EditableListView from '@/components/common/EditableListView'
import { mapState, mapGetters } from 'vuex'
import MultipleProfilePicker from '@/components/profile/MultipleProfilePicker'
import axios from 'axios'
import { userApi as honeyUserApi } from '../../api'
import { honeyRolesApi } from '../../api'

export default {
  props: {
    honeyUser: Object
  },

  data() {
    return {
      honeyUserReplicateLoader: false,
      editUsername: false,
      honeyUserUpdating: false,
      honeyUserHoneyRoleUpdating: false,
      honeyUserProfileUpdating: false,
      active: !this.honeyUser.deactivated,
      activeConfirmDialog: false,
      username: this.honeyUser.username,
      searchAttributes: ['name', 'description', 'hexId'],
      honeyRoles: [],
      honeyUserHoneyRoles: []
    }
  },

  computed: {
    ...mapState({
      // honeyRoles: state => state.honeyRoles.honeyRoles,
      // honeyUserHoneyRoles: state => state.honeyUsers.honeyUserHoneyRoles,
      honeyUserProfiles: state => state.honeyUsers.honeyUserProfiles
    }),
    ...mapGetters({
      can: 'can'
    })
  },

  watch: {
    honeyUser() {
      this.active = !this.honeyUser.deactivated
      this.getAssociations()
    }
  },

  created() {
    if (this.honeyUser) {
      this.getAssociations()
    }
    this.getHoneyRoles()
  },

  methods: {
    getAssociations() {
      this.getHoneyUserHoneyRoles()
      this.getHoneyUserProfiles()
    },

    async replicateToWorkflowEngine() {
      this.honeyUserReplicateLoader = true
      try {
        await axios.post(
          `/api/v1/honeyUsers/${this.honeyUser.hexId}/replicate-user-email`
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Replicate user to workflow engine successfully',
          description: 'Replicate user to workflow engine successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to replicate user to workflow engine',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.honeyUserReplicateLoader = false
    },

    async getHoneyUserHoneyRoles() {
      this.honeyUserHoneyRoleUpdating = true
      try {
        // await this.$store.dispatch('fetchHoneyUserHoneyRoles', this.honeyUser)
        this.honeyUserHoneyRoles = await honeyUserApi.fetchHoneyUserHoneyRoles(
          this.honeyUser
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Role for the User',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.honeyUserHoneyRoleUpdating = false
    },

    async getHoneyUserProfiles() {
      this.honeyUserProfileUpdating = true
      try {
        await this.$store.dispatch('fetchHoneyUserProfiles', this.honeyUser)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Profile(s) for the User',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.honeyUserProfileUpdating = false
    },

    async getHoneyRoles() {
      this.honeyUserHoneyRoleUpdating = true
      try {
        await this.$store.dispatch('fetchHoneyRoles')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Role',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.honeyUserHoneyRoleUpdating = false
    },

    async honeyRolesAdded(honeyRoles) {
      this.honeyUserHoneyRoleUpdating = true
      try {
        // await this.$store.dispatch('addHoneyRoleToHoneyUser', {
        //   honeyRoles,
        //   honeyUser: this.honeyUser
        // })
        honeyUserApi.addHoneyRoleToHoneyUser(honeyRoles, this.honeyUser)
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Role added to the User Successfully',
          description: 'Role added to the User Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to add Role',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        this.honeyUserHoneyRoles = await honeyUserApi.fetchHoneyUserHoneyRoles(
          this.honeyUser
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Role for the User',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.honeyUserHoneyRoleUpdating = false
    },

    async honeyRolesDeleted(honeyRoles) {
      this.honeyUserHoneyRoleUpdating = true
      try {
        // await this.$store.dispatch('deleteHoneyRoleFromHoneyUser', {
        //   honeyRoles,
        //   honeyUser: this.honeyUser
        // })
        await honeyUserApi.deleteHoneyRoleFromHoneyUser(
          honeyRoles,
          this.honeyUser
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Role updated for the User Successfully',
          description: 'Roles updated for the User Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to update Role',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        // await this.$store.dispatch('fetchHoneyUserHoneyRoles', this.honeyUser)
        this.honeyUserHoneyRoles = await honeyUserApi.fetchHoneyUserHoneyRoles(
          this.honeyUser
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Role for User',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.honeyUserHoneyRoleUpdating = false
    },

    async setProfiles(profileIds) {
      this.honeyUserProfileUpdating = true
      try {
        await this.$store.dispatch('addProfilesToHoneyUser', {
          profileIds,
          honeyUser: this.honeyUser
        })
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Profile(s) updated for the User Successfully',
          description: 'Profile(s) updated for the User Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to add Profile(s)',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        await this.$store.dispatch('fetchHoneyUserProfiles', this.honeyUser)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Profile(s) for the User',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.honeyUserProfileUpdating = false
    },

    async setActive(status) {
      this.honeyUserUpdating = true
      this.activeConfirmDialog = false
      let currentState = this.active
      if (status) {
        try {
          await this.$store.dispatch('changeUserActivationStatus', {
            body: { deactivated: !this.active },
            hexId: this.honeyUser.hexId
          })
          let message = ''
          if (currentState) {
            message = 'User activated Successfully'
          } else {
            message = 'User de-activated Successfully'
          }
          await this.$store.dispatch('directNotification', {
            message: message,
            type: 'success',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        } catch (e) {
          let message = ''
          if (currentState) {
            message = 'User activation Failed'
          } else {
            message = 'User de-activation Failed'
          }
          await this.$store.dispatch('directNotification', {
            message: message,
            description: e.response
              ? e.response.data.message
              : 'Error unknown! Kindly retry',
            type: 'error',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
          this.resetActive()
        }
      } else {
        this.resetActive()
      }
      this.honeyUserUpdating = false
    },

    resetActive() {
      this.active = !this.honeyUser.active
    },
    async search(query) {
      try {
        this.honeyRoles = await honeyRolesApi.fetchHoneyRoles(query)
      } catch (e) {
        console.log(e)
      }
    }
  },

  components: {
    EditableListView,
    MultipleProfilePicker
  }
}
</script>
<template>
  <v-card class="beez-card">
    <v-toolbar dense card class="elevation-2">
      <v-toolbar-title class="body-2 beez-bold ">
        {{ honeyUser.username }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          flat
          icon
          @click.stop="replicateToWorkflowEngine"
          :loading="honeyUserReplicateLoader"
        >
          <v-icon>
            sync_alt
          </v-icon>
        </v-btn>
        <span>Replicate To Workflow Engine</span>
      </v-tooltip>
      <v-dialog
        v-model="activeConfirmDialog"
        persistent
        max-width="290"
        :class="{ 'pull-right': $vuetify.breakpoint.mdAndUp }"
        v-if="can('USER_DEACTIVATE')"
      >
        <input
          class="apple-switch"
          type="checkbox"
          label="Active"
          color="success"
          v-model="active"
          slot="activator"
        />
        <v-card style="border-radius: 5px;">
          <div v-if="!active">
            <v-card-text class="subheading"
              >Confirm de-activating the User - {{ honeyUser.username }}
            </v-card-text>
          </div>
          <div v-else>
            <v-card-text class="subheading"
              >Confirm activating the User - {{ honeyUser.username }}
            </v-card-text>
          </div>
          <v-card-actions>
            <v-spacer />
            <v-btn flat icon @click="setActive(false)">
              <v-icon>close</v-icon>
            </v-btn>
            <v-btn flat icon class="primary" @click="setActive(true)">
              <v-icon>check</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-progress-linear
      indeterminate
      class="ma-0"
      color="accent"
      height="5"
      :active="honeyUserUpdating"
    />
    <div class="pa-3">
      <v-text-field
        :outline="$vuetify.dark"
        color="secondary"
        label="Name"
        v-model="honeyUser.username"
        required
        disabled
      >
      </v-text-field>
      <div class="py-4" v-if="can('USER_ROLE')">
        <editable-list-view
          title="Honey Roles"
          :selectedItems="honeyUserHoneyRoles"
          :allItems="honeyRoles"
          :updating="honeyUserHoneyRoleUpdating"
          :key="'role -' + honeyUser.hexId"
          @added="honeyRolesAdded"
          @deleted="honeyRolesDeleted"
          :search-attributes="searchAttributes"
          @queryChanged="query => search(query)"
        >
          <template slot="empty-list-placeholder-selected">
            Please click the edit icon to start adding Honey Roles.
          </template>

          <template
            :slot="slotName"
            v-for="(slotName, i) in [
              'list-item-selected',
              'list-item-add',
              'list-item-delete'
            ]"
            slot-scope="slotProps"
          >
            <v-list-tile-content :key="i + 'avatar-content'">
              <v-container fulid>
                <v-layout row>
                  <v-flex shrink>
                    <v-list-tile-avatar :key="i + 'avatar'">
                      <vue-letter-avatar
                        :name="slotProps.item.name"
                        size="40"
                        :rounded="true"
                      />
                    </v-list-tile-avatar>
                  </v-flex>
                  <v-flex grow>
                    <v-list-tile-title
                      >{{ slotProps.item.name }}
                    </v-list-tile-title>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-list-tile-content>
          </template>
        </editable-list-view>
      </div>
      <multiple-profile-picker
        v-if="can('USER_PROFILE')"
        @finish="setProfiles"
        :outer-updating="honeyUserProfileUpdating"
        :value="honeyUserProfiles[honeyUser.hexId]"
      />
    </div>
  </v-card>
</template>
